/* @flow */

import React from "react";

import { BusinessAccountResponse } from "../../../../datatypes/businessaccounts/BusinessAccount";
import { FormattedMessage } from "react-intl";
import { AccountLinks, ActionLink } from "./AccountLinks";

type Props = {
    businessAccountData: BusinessAccountResponse;
    setAccountDropDownPage: (x0: number) => void;
};

export class PersonAccountLinksList extends React.Component<Props> {
    renderAccountSwitch(businessAccountData: BusinessAccountResponse) {
        const label = businessAccountData.labels?.switchAccount?.text ?? (
            <FormattedMessage id={"CA_BUSINESS_ACCOUNTS_LIST"} />
        );
        return (
            <li className="test-account-switch-link">
                <a
                    href="/"
                    className="clickable"
                    onClick={(e) => {
                        e.preventDefault();
                        this.props.setAccountDropDownPage(2);
                    }}>
                    {label}
                </a>
                <span className="caret" />
            </li>
        );
    }

    render() {
        const businessAccountData = this.props.businessAccountData;
        if (!businessAccountData) {
            // most people do not have business accounts,
            // we don't want to confuse them with an empty dropdown:
            return null;
        }
        const size = businessAccountData.accountData.length;
        if (size <= 0) {
            return null;
        }
        const activeAccount = businessAccountData.getActiveAccount();
        const registerAction = activeAccount?.actions?.registerNewAccount;
        return (
            <React.Fragment>
                <AccountLinks account={activeAccount} />
                {size > 1 && this.renderAccountSwitch(businessAccountData)}
                {registerAction && <ActionLink action={registerAction} />}
            </React.Fragment>
        );
    }
}
